import {Calendar} from '@fullcalendar/core' // eslint-disable-line import/no-extraneous-dependencies
import dayGridPlugin from '@fullcalendar/daygrid' // eslint-disable-line import/no-extraneous-dependencies
import interactionPlugin from '@fullcalendar/interaction' // eslint-disable-line import/no-extraneous-dependencies
import listPlugin from '@fullcalendar/list' // eslint-disable-line import/no-extraneous-dependencies

function initialize(url) {
  const calendarElement = document.getElementById('calendar')

  if (!calendarElement)
    return

  window.gf.calendar = new Calendar(calendarElement, {
    backgroundColor: '#FFFFFF', // searching for $white-color? find me!
    dateClick: () => {
      $('.popover').remove()
    },
    eventClick: (args) => {
      Turbo.visit(args.event.extendedProps.path, {frame: 'remote-modal'})
    },
    eventColor: '#087F97', // searching for $color-link? find me!
    events: url,
    height: 'parent',
    headerToolbar: {
      start: '',
      center: 'prev,title,next',
      end: 'listWeek,dayGridWeek,dayGridMonth',
    },
    plugins: [
      dayGridPlugin,
      interactionPlugin,
      listPlugin,
    ],
    theme: 'bootstrap',
  })

  window.gf.calendar.render()
}

export default {initialize}
